<template>
    <div class="btn-group">
        <button class="btn btn-default"
            v-for="option in effectiveOptions"
            :class="buttonClass(option)"
            :disabled="disabled"
            @click="toggleValue(option.value)"
            v-html="option.title"
            ></button>
    </div>
</template>

<script>
export default {
    props: {
        value: null,
        options: null,
        disabled: null,
        btnClass: null,
        inactiveBtnClass: { default: 'btn-default' },
        activeBtnClass: { default: 'btn-info' },
        nullable: { default: true },
    },
    computed: {
        effectiveOptions() {
            if (!this.options) {
                return [
                    { title: 'Yes', value: true },
                    { title: 'No', value: false },
                ];
            }

            if (!Array.isArray(this.options)) {
                return Object.keys(this.options).map(key => ({ title: this.options[key], value: key }));
            }

            return this.options;
        },
    },
    methods: {
        buttonClass(option) {
            let active = this.value === option.value;

            let classes = { 'active': active };
            if (this.inactiveBtnClass)
                classes[this.inactiveBtnClass] = !active;
            if (this.activeBtnClass)
                classes[this.activeBtnClass] = active;

            return [classes, this.btnClass];
        },
        toggleValue(value) {
            if (this.value === value && this.nullable)
                this.$emit('input', null);
            else
                this.$emit('input', value);
        },
    },
}
</script>
